<template>
	<div class="grid-flex-container pa-4">
		<v-container class="py-6" fluid>
			<v-row>
				<div style="flex-grow: 1">
					<v-text-field
						v-if="canView"
						v-model="search"
						class="py-0 my-0 mb-2 mr-2"
						append-icon="mdi-magnify"
						label="Search"
						single-line
						hide-details
					/>
				</div>
				<v-btn v-if="canAdd" color="primary" @click="onAdd()">
					<v-icon> mdi-plus</v-icon>
					&nbsp;&nbsp;Add
				</v-btn>
			</v-row>
		</v-container>
		<div class="generic-grid-container">
			<v-data-table
				v-if="canView"
				dense
				:items="computedFields"
				:headers="headers"
				:search.sync="search"
				:loading="loading"
				disable-pagination
				fixed-header
				hide-default-footer
				loading-text="Loading..."
			>
				<template v-slot:[`item.IsVisible`]="{ item }">
					<span v-if="item.IsVisible === true">Is visible</span>
					<span v-else>Is not visible</span>
				</template>
				<template v-slot:[`item.AgregateFunction`]="{ item }">
					{{ getAgregateFunction(item.AgregateFunction) }}
				</template>
				<template v-slot:[`item.actions`]="{ item }">
					<v-btn
						v-if="canEdit"
						fab
						small
						icon
						elevation="1"
						class="action-btn"
						@click.stop="editComputedField(item.Id)"
					>
						<v-icon color="primary" small>mdi-pencil</v-icon>
					</v-btn>
					<v-btn
						v-if="canDelete"
						fab
						small
						icon
						elevation="1"
						class="action-btn"
						@click.stop="deleteComputedField(item)"
					>
						<v-icon color="error" small>mdi-delete</v-icon>
					</v-btn>
				</template>
			</v-data-table>
		</div>
		<activity-computed-field-modal
			:showDialog="showDialog"
			:computedField="selectedComputedField"
			@close="closeComputedFieldModal()"
		/>
	</div>
</template>
<script>
import ActivityComputedFieldModal from './ActivityComputedFieldModal.vue';
import { mapGetters } from 'vuex';
import { ActivityComputedFieldsGetters } from '../../../../store/getters';
import { ActivityComputedFieldsActions } from '../../../../store/actions';
import ConfirmDialog from '@/components/core/dialogs/confirmDialog';
import { agregateFunctions } from '../../../../enums/agregateFunctions';
import permissionsMixin from '../../../../mixins/permissionsMixin';
import { Permissions } from '../../../../enums/permissionsEnum';
export default {
	name: 'ActivityComputedFields',
	components: { ActivityComputedFieldModal },
	mixins: [permissionsMixin],
	data() {
		return {
			showDialog: false,
			selectedComputedField: {},
			search: '',
			headers: [
				{ text: 'Name', value: 'Name' },
				{ text: 'Agregate Function', value: 'AgregateFunction' },
				{ text: '', value: 'actions', sortable: false, align: 'end' },
			],
		};
	},
	computed: {
		...mapGetters({
			computedFields: [ActivityComputedFieldsGetters.COMPUTED_FIELDS],
			loading: [ActivityComputedFieldsGetters.LOADING],
		}),
		canView() {
			return this.hasPermissions([
				Permissions.Tools.ActivityBuilder.ComputedFields.View,
			]);
		},
		canAdd() {
			return this.hasPermissions([
				Permissions.Tools.ActivityBuilder.ComputedFields.Add,
			]);
		},
		canEdit() {
			return this.hasPermissions([
				Permissions.Tools.ActivityBuilder.ComputedFields.Edit,
			]);
		},
		canDelete() {
			return this.hasPermissions([
				Permissions.Tools.ActivityBuilder.ComputedFields.Delete,
			]);
		},
	},
	mounted() {
		this.$store.dispatch(
			ActivityComputedFieldsActions.LOAD,
			this.$route.params.id
		);
	},
	destroyed() {
		this.$store.dispatch(ActivityComputedFieldsActions.CLEAR);
	},
	methods: {
		getAgregateFunction(param) {
			switch (param) {
				case agregateFunctions.COUNT:
					return 'Count';
				case agregateFunctions.MAX:
					return 'Max';
				case agregateFunctions.Min:
					return 'Min';
				case agregateFunctions.SUM:
					return 'Sum';
				default:
					return '';
			}
		},
		onAdd() {
			this.showDialog = true;
		},
		closeComputedFieldModal() {
			this.showDialog = false;
			this.selectedComputedField = {};
		},
		deleteComputedField(item) {
			ConfirmDialog({
				message: 'Are you sure you want to delete this computed field?',
			}).then((isDelete) => {
				if (!isDelete) return;
				this.$store.dispatch(
					ActivityComputedFieldsActions.DELETE_COMPUTED_FIELD,
					item.Id
				);
			});
		},
		editComputedField(id) {
			this.$store
				.dispatch(
					ActivityComputedFieldsActions.LOAD_COMPUTED_FIELD_BY_ID,
					id
				)
				.then((resp) => {
					this.selectedComputedField = resp;
					this.selectedComputedField.Filters =
						resp.ActivityComputedFieldFilters.map((x) => ({
							GridViewFieldId: x.GridViewFieldId,
							FieldId: x.GridViewFieldId,
							Operator: x.Operator,
							Value: x.Value,
						}));
					this.showDialog = true;
				});
		},
	},
};
</script>
